import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  state: {
    devices: [],
    devicesLoading: false
  },
  mutations: {
    setDevices(state, devices) {
      state.devices = devices;
    },
    setDevicesLoading(state, loading) {
      state.devicesLoading = loading;
    }
  },
  actions: {
    async loadDevices({ commit }) {
      commit("setDevicesLoading", true);
      let devices = await api.get("devices");
      commit("setDevices", devices.data);
      commit("setDevicesLoading", false);
    },
    async newDevice({ commit, dispatch }, payload) {
      let device = await api.post("devices", payload);
      dispatch("loadDevices");
      dispatch("loadApplications");
      return device.data;
    },
    async saveDevice({ commit, dispatch }, payload) {
      await api.put("devices", payload);
      dispatch("loadDevices");
    }
  },
  getters: {
    devicesLoading(state) {
      return state.devicesLoading;
    },
    devices(state) {
      return state.devices;
    }
  }
};
